// extracted by mini-css-extract-plugin
export default {"main":"Nav_main__Ycf8O","logo":"Nav_logo__xRkLF","mode":"Nav_mode__pVwid","img":"Nav_img__KgJQj"};